import { contains } from 'ramda';
import { Layout, SettingsLayout } from '../constants/Layout';

export const toLayout = (settingsLayout: SettingsLayout): Layout =>
  contains(settingsLayout, [SettingsLayout.GalleryWithPanel]) ? Layout.Gallery : Layout.List;

export const toSettingsLayout = (layout: Layout): SettingsLayout =>
  layout === Layout.Gallery ? SettingsLayout.GalleryWithPanel : SettingsLayout.ListWithPanel;
